import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { FamilienStand, Tarifbereich } from '@ps20/bff-models';
import {
  BasisAdresse,
  determineAssekuranztarifFromTarifbereich,
} from '@ps20-frontend/frontend-models';

export interface Versicherungsnehmer {
  geburtsdatum: string;
  familienstand: FamilienStand;
  isAssekuranztarif: boolean;
  tarifbereich?: Tarifbereich;
  adresse: BasisAdresse;
}

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
): Versicherungsnehmer {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      if (action.payload.versicherungsnehmer?.geburtsdatum) {
        const dateSplitted = action.payload.versicherungsnehmer.geburtsdatum.split('-');
        const dateAsString = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;
        const vnAdresse: BasisAdresse = action.payload.versicherungsnehmer.adresse;
        return {
          ...sectionState,
          geburtsdatum: dateAsString,
          adresse: {
            plz: vnAdresse.plz,
            strasse: vnAdresse.strasse,
            ort: vnAdresse.ort,
            hausnummer: vnAdresse.hausnummer,
          },
        };
      } else {
        return sectionState;
      }
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
      };
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    }
    default:
      return sectionState;
  }
};
